
export default function url() {

    var puerto, URL, SERVIDOR, clientId, url_excel

    if (false) {

        puerto = 8000;
        URL = `http://localhost:${ puerto }/funciones/fetch.php`
        SERVIDOR = `http://localhost:${ puerto }`;
        clientId = `111799552534-saoa27kvajuph46nvg068sptog57h17i.apps.googleusercontent.com`;
        url_excel = `http://localhost:${ puerto }/funciones/fetch.php?funcion=generarExcel`

    } else {
        // URL = `http://localhost/empleados/backend/funciones/fetch.php`
        // SERVIDOR = `http://empleado.atuorden.mx/backend`;
        // clientId = `111799552534-saoa27kvajuph46nvg068sptog57h17i.apps.googleusercontent.com`;
        clientId = `1006356263827-7fasqe2n40n74ibaanca59p06qdsl582.apps.googleusercontent.com`;
        // url_excel = `https://empleado.atuorden.mx/backend/funciones/fetch.php?funcion=generarExcel`
        URL = `https://empleado.utescuinapa.edu.mx/backend/funciones/fetch.php`
        SERVIDOR = `https://empleado.utescuinapa.edu.mx/backend`;
        url_excel = `https://empleado.utescuinapa.edu.mx/backend/funciones/fetch.php?funcion=generarExcel`
    }


    return {
        URL,
        SERVIDOR,
        clientId,
        url_excel
    }
}

// registro-empleados
